// extracted by mini-css-extract-plugin
export default {"columns":"TableOptionsModal-columns-PtB2N"};